import { useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router'

import { Container } from '@material-ui/core'
import { ErrorBoundary } from '@scoir/error-reporter'
import { PageTitle } from '@scoir/headers'

import useTitle from 'common/use-title'
import DynamicContentProvider from 'components/DynamicContentProvider'
import EngageSplashPage from 'components/EngageSplashPage'

import PremiumInsights from './PremiumInsights'
import ContentManagement from './ContentManagement'

interface ContentManagementRouteProps extends RouteComponentProps {
  canManageContent: boolean
  supportsContentManagement: boolean
}
const ContentManagementRoute = ({ supportsContentManagement, canManageContent }: ContentManagementRouteProps) => {
  useTitle('Scoir - Premium Presence')
  const user = useSelector((state: any) => state.user.record)
  const isAccountAdmin = user.Roles?.includes('AdmissionsAdministrator')

  const canViewPremiumPresenceInsights =
    user.IsShadow || (supportsContentManagement && (isAccountAdmin || canManageContent))

  // Display splash page if content management feature is not enabled
  if (!supportsContentManagement) {
    return (
      <EngageSplashPage
        type="presence"
        featureEnabled={supportsContentManagement}
      />
    )
  }

  return (
    <DynamicContentProvider>
      <Container maxWidth="xl">
        <PageTitle title="Premium Presence" />
        {/* Only display premium presence insights to Account Administrators or Content Managers */}
        {canViewPremiumPresenceInsights ? (
          <ErrorBoundary>
            <PremiumInsights />
          </ErrorBoundary>
        ) : null}
        <ErrorBoundary>
          <ContentManagement canManageContent={canManageContent} />
        </ErrorBoundary>
      </Container>
    </DynamicContentProvider>
  )
}

export default ContentManagementRoute
